import { render } from "./NavigationBar.vue?vue&type=template&id=518b2cb8&scoped=true"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"

import "./NavigationBar.vue?vue&type=style&index=0&id=518b2cb8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-518b2cb8"

export default script